import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminBlogEditor from "@/pages/AdminBlogEditor";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/blog/$id")({
  head: ({ params }) => seoHead(`/admin/blog/${params.id}`),
  component: () => (
    <StaffAdminGate><AdminBlogEditor /></StaffAdminGate>
  ),
});
